import { type AchLimits, type AchLimitsError, type BankAccountDetail, useWealthOverview } from '@egw/api'
import { type Dispatch, type SetStateAction, useEffect, useMemo } from 'react'
import { type TransferAccounts } from '../types'
import { checkIfAchAccount, checkIfBankAccount } from '../utils'

interface AccountTransferLimits {
  alias: number | null | undefined
  accountType: TransferAccounts | undefined
  onSettledCb: Dispatch<SetStateAction<AchLimits | AchLimitsError | undefined>>
}

export const useAccountTransferLimits = ({ alias, accountType, onSettledCb }: AccountTransferLimits): void => {
  const hoistAchLimits = useMemo(
    () =>
      Boolean(typeof alias === 'number') &&
      alias !== -1 &&
      accountType &&
      (checkIfBankAccount(accountType) || checkIfAchAccount(accountType)),
    [alias, accountType],
  )

  const { data } = useWealthOverview()

  const allAccounts = useMemo(
    () => [...(data?.highYieldChecking?.accounts ?? []), ...(data?.highYieldSavings?.accounts ?? [])],
    [data],
  )

  useEffect(() => {
    if (hoistAchLimits) {
      const achLimits = allAccounts.find((account: BankAccountDetail) => account.alias === alias)?.achLimits
      onSettledCb(achLimits)
    }
  }, [alias, allAccounts, hoistAchLimits, onSettledCb])
}
